var _rect, _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyAvatarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 220,
    width: 220,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    width: 240,
    height: 240,
    rx: 4,
    transform: "rotate(90 240 0)",
    fill: "url(#paint0_linear_2884_2408)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.334 240C213.334 208.667 189.965 175.439 163.56 161.624C149.396 154.213 136.991 152 120 152C103.01 152 89.134 154.985 76.4414 161.624C50.0352 175.435 26.667 209.333 26.667 240C89.7781 240 150.223 240 213.334 240Z",
    fill: "#FAFBFC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2884_2408",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 152,
    width: 188,
    height: 88
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1488 240H205.852C208.145 240 210.283 239.072 211.718 237.455C212.965 236.053 213.517 234.273 213.28 232.446C209.254 201.351 189.965 175.439 163.56 161.624C149.396 154.213 136.991 152 120 152C103.01 152 89.1341 154.985 76.4414 161.624C50.0352 175.435 30.7431 201.351 26.7204 232.446C26.4837 234.273 27.0391 236.056 28.2823 237.455C29.7172 239.072 31.8555 240 34.1488 240Z",
    fill: "#A5CDFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2884_2408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.2333 163.352C82.2363 164.404 83.2838 165.407 84.368 166.377C93.8385 174.848 106.292 180.046 119.966 180.046C133.64 180.046 146.094 174.844 155.564 166.377C156.648 165.407 157.696 164.404 158.699 163.352C159.697 162.3 160.672 161.224 161.588 160.095C169.008 150.907 173.477 139.239 173.477 126.535C173.477 97.0272 149.469 73.0238 119.965 73.0238C90.4614 73.0238 66.4551 97.0309 66.4551 126.535C66.4551 139.238 70.9239 150.907 78.3439 160.094C79.2566 161.224 80.2303 162.297 81.2333 163.352Z",
    fill: "#D5DCE9"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2333 152.995C82.2363 154.047 83.2838 155.049 84.368 156.019C93.8385 164.491 106.292 169.689 119.966 169.689C133.64 169.689 146.094 164.487 155.564 156.019C156.648 155.049 157.696 154.046 158.699 152.995C159.697 151.943 160.672 150.867 161.588 149.738C169.008 140.55 173.477 128.882 173.477 116.178C173.477 86.67 149.469 62.6667 119.965 62.6667C90.4614 62.6667 66.4551 86.6738 66.4551 116.178C66.4551 128.881 70.9239 140.55 78.3439 149.737C79.2566 150.867 80.2303 151.94 81.2333 152.995Z",
    fill: "#FAFBFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2884_2408",
    x1: 242,
    y1: 240,
    x2: 307.76,
    y2: -35.2013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "#E5EEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDDEF7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAvatarIcon);
export default __webpack_public_path__ + "static-react/media/empty-avatar-icon.7a2dcc756d26e8c96065736f26ecfa6b.svg";
export { ForwardRef as ReactComponent };